module.exports = __webpack_public_path__ + "static/media/dfw-9ball-tour.54135814.jpg";